/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from "react";
import intl from 'react-intl-universal';
import { FACEBOOK_FING_URL, LINKEDIN_FING_URL, TWITTER_FING_URL } from "../Constants";

import NavbarLogo from './navbar/NavbarLogo';

class Loading extends React.Component {
    
    render() {
        return (
            <div>

                <header id="header" className="header header-bg-transparent header-abs-top">
                    <div className="header-section">
                        <div id="logoAndNav" className="container">
                            <nav className="navbar navbar-expand-md px-3 py-2">
                                <NavbarLogo />
                            </nav>
                        </div>
                    </div>
                </header>

                <main id="content" role="main">
                    <div className="d-lg-flex">
                        <div className="h1 container d-lg-flex align-items-lg-center min-vh-lg-100 space-4">
                            {intl.get('loading_running')}
                        </div>
                    </div>
                </main>

                <footer className="position-md-absolute right-md-0 bottom-md-0 left-md-0">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center space-1">
                            <p className="small text-muted mb-0">&copy; Fing 2019.</p>

                            <ul className="list-inline mb-0">
                                <li className="list-inline-item">
                                    <a className="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent"
                                       href={FACEBOOK_FING_URL}>
                                        <span className="fab fa-facebook-f btn-icon__inner"/>
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a className="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent"
                                       href="https://twitter.com/fingapp">
                                        <svg 
                                            className="x-twitter"
                                            xmlns="http://www.w3.org/2000/svg" 
                                            height="16px" 
                                            width="16px"
                                            viewBox="0 0 512 512">
                                            <path fill="#8c98a4" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                                        </svg>
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a className="btn btn-sm btn-icon btn-soft-secondary btn-bg-transparent"
                                       href={LINKEDIN_FING_URL}>
                                        <span className="fab fa-linkedin btn-icon__inner"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Loading;